import React, { memo } from 'react';
import ReactModal from 'react-modal';
import moment from 'moment';

import { ActionButton } from '../../../common';
import { viewDocument } from '../../../../helpers/data-constants';
import { HookForm, HInput, HDatePicker, HTextarea } from '../../../../validation/HForm';
import { toFormInventoryShema, toFormWithdrawalShema } from './toFormWithdrawalInventoryModalShema';

import './toFormWithdrawalInventoryModal.scss';

const defaultFormState = {
  documentNumber: '',
  reason: '',
  transferDate: moment().format('YYYY-MM-DD'),
};

const ToFormWithdrawalInventoryModal = memo(
  ({
    isOpen,
    handleCloseModal,
    view,
    cashBoxInfo,
    dealIds,
    submitTransferDeals,
    permissibleDate,
  }) => {
    let form = {};
    const inventory = view === viewDocument.isInventory ? viewDocument.isInventory : false;
    const withdrawal = view === viewDocument.isWithdrawal ? viewDocument.isWithdrawal : false;
    const dataPermissibleDate =
      permissibleDate !== null && typeof permissibleDate === 'string'
        ? permissibleDate
        : moment().subtract(permissibleDate, 'days').format('YYYY-MM-DD');

     const handleOpenClose = () => {
      if (inventory) handleCloseModal(inventory);
      if (withdrawal) handleCloseModal(withdrawal);
    };

    const handleSubmit = (data) => {
      let name = false;
      let identity = false;

      if (inventory) {
        data = {
          type: 'inventory',
          dealIds,
          documentNumber: data.documentNumber,
          transferDate: moment(data.transferDate).format('YYYY-MM-DD'),
          reason: data.reason,
        };
      }

      if (withdrawal) {
        name = data.withdrawalName;
        identity = data.withdrawalDocuments;

        data = {
          type: 'withdrawal',
          dealIds,
          documentNumber: data.documentNumber,
          transferDate: moment(data.transferDate).format('YYYY-MM-DD'),
          reason: data.reason,
        };
      }

      submitTransferDeals(data, name, identity);
      if (inventory) handleCloseModal(inventory);
      if (withdrawal) handleCloseModal(withdrawal);
    };

    return (
      <ReactModal
        isOpen={isOpen}
        contentLabel="Modal"
        className="modal-container toFormWithdrawalInventoryModal-modal-container"
        overlayClassName="modal-overlay">
        <HookForm
          onSubmit={handleSubmit}
          validationSchema={inventory ? toFormInventoryShema : toFormWithdrawalShema}
          defaultValues={defaultFormState}
          predef={(methods) => (form = methods)}>
          <div className="modal-header">
            {inventory && <h2>Инвентарь</h2>}
            {withdrawal && <h2>Изъятие</h2>}
          </div>
          <div className="modal-body">
            <div>
              <p>
                Подразделение: <b>{cashBoxInfo.name}</b>
              </p>
              <p>Адрес: {cashBoxInfo.address}</p>
            </div>
            <div className="toFormWithdrawalInventoryModal-container">
              <div className="form-element">
                <label className="form-element-label" htmlFor="documentNumber">
                  Номер документа
                </label>
                <div className="form-element-data combobox">
                  <HInput
                    h="true"
                    name="documentNumber"
                    className="input"
                    type="text"
                    decimals={0}
                  />
                </div>
              </div>
              <div className="form-element">
                <label className="form-element-label" htmlFor="transferDate">
                  Дата передачи
                </label>
                <div className="form-element-data date">
                  <HDatePicker h="true" className="input" name="transferDate" id="transferDate" />

                  {inventory && (
                    <HDatePicker
                      h="true"
                      type="hidden"
                      name="permissibleDate"
                      id="permissibleDate"
                      defaultValue={dataPermissibleDate}
                    />
                  )}
                </div>
              </div>
            </div>
            {withdrawal && (
              <>
                <div className="form-element">
                  <label className="form-element-label" htmlFor="withdrawalName">
                    ФИО изымающего лица
                  </label>
                  <div className="form-element-data textarea">
                    <HInput h="true" name="withdrawalName" className="input" type="text" />
                  </div>
                </div>
                <div className="form-element">
                  <label className="form-element-label" htmlFor="withdrawalDocuments">
                    Документы
                  </label>
                  <div className="form-element-data textarea">
                    <HInput h="true" name="withdrawalDocuments" className="input" type="text" />
                  </div>
                </div>
              </>
            )}
            <div className="form-element">
              <label className="form-element-label" htmlFor="reason">
                Основание
              </label>
              <div className="form-element-data textarea">
                <HTextarea h="true" className="input" name="reason" />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <ActionButton text="Сохранить" styleName="button" submit />
            <ActionButton text="Отменить" func={handleOpenClose} styleName="button-light" />
          </div>
        </HookForm>
      </ReactModal>
    );
  },
);

export default ToFormWithdrawalInventoryModal;
